import React, { Component } from "react";
import {getAnswersWithSkip, getAvailableInstitutions, getResponse} from "../../../../services/formService";
import Select from "react-select";
import _ from 'lodash';
class InstitutionViewer extends Component {


    constructor(props){
        super(props);
        const{isMultiple} =this.props;
        this.state = {
            Question_ID: this.props.Question_ID,
            questionAnswers: [],
            Answer_ID: this.props.Answer_ID ? this.props.Answer_ID : 0,
            Response_Required: this.props.Response_Required,
            loading: true,
            answerSelectedList:[],
            isMultiple,
            isTopLevel: this.props.isTopLevel ? this.props.isTopLevel : false,
            selectedInst: this.props.selectedInst
        };
    }

    async componentDidMount() {
        const{Question_ID} = this.state;
        const{PrimaryKey,Project_ID}=this.props;
        let { data: oldQuestionAnswers } = await getAvailableInstitutions(
            Project_ID
        );

        const { data: oldAnswerSelectedList } = await getResponse(
            PrimaryKey,
            Project_ID,
            Question_ID
        );

        const questionAnswers = _(oldQuestionAnswers)
            .map(obj=>{
                return {
                    Question_ID,
                    Answer_ID: obj.Institution_ID,
                    Answer_Text: obj.Institution_Name,
                    label: obj.Institution_Name,
                    code: obj.Institution_Code,
                    value: obj.Institution_ID,
                };
            })
            .value();

        const answerSelectedList = _(questionAnswers).filter(obj=>{
            return _(oldAnswerSelectedList).find(ans=>ans.Answer_ID ===obj.Answer_ID)
        }).value();
        this.setState({ questionAnswers,answerSelectedList });
        if (this.state.Answer_ID > 0) {
            this.handleSelection({ target: { value: this.props.Answer_ID } });
        }
        else {
            this.setState({ Answer_ID: questionAnswers[0] ? questionAnswers[0].Answer_ID : 0})
            this.handleSelection({ target: { value: this.state.Answer_ID } });
        }
        this.setState({ loading: false });
    }

    handleSelection = ({ target }) => {
            let Answer_ID = parseInt(target.value);
            let selected = this.state.questionAnswers.filter(
                (ans) => ans.Answer_ID === Answer_ID
            )[0] || [];

            this.props.OnUpdate(this.props.Question_Number, {
                Responses:
                    Answer_ID && Answer_ID.toString() === '0'
                        ? []
                        : [
                            {
                                Question_ID: this.state.Question_ID,
                                Answer_ID: selected.Answer_ID,
                                Answer_Text: selected.Answer_Text,
                                Institution_Code: selected.code
                            },
                        ],
                Skip: selected.SkipLogic != null ? selected.SkipLogic : [],
                Response_Required: !this.state.loading && this.state.Response_Required,
            });
            this.setState({ Answer_ID });
            localStorage.setItem('Inst_ID', Answer_ID)
    };

    handleMultiSelection = (answerSelectedList) =>{
        this.props.OnUpdate(this.props.Question_Number, {
            Responses:answerSelectedList,
            Skip: answerSelectedList && answerSelectedList.length > 0 && answerSelectedList[0].SkipLogic != null ? answerSelectedList[0].SkipLogic : [],
            Response_Required: !this.state.loading && this.state.Response_Required,
        });
        this.setState({ answerSelectedList });
    }

    render() {
        if (this.state.loading) return <div className="center">Loading...</div>;
        const { answerSelectedList, Question_ID, questionAnswers, Answer_ID, isMultiple, isTopLevel } = this.state;
        return (
            <div className="form-group" key={this.state.selectedInst}>

                {
                    !isMultiple && <select disabled={questionAnswers.length === 1 || this.props.disabled}
                        className="form-control"
                        onChange={isTopLevel ? this.handleSelection : () => {}}
                        value={Answer_ID}
                        id='userInst'
                    >
                        {questionAnswers.map((ans) => (
                            <option key={"mAns" + ans.value} value={ans.value} code={ans.code} name={'userInst-' + ans.value}>
                                {ans.label}
                            </option>
                        ))}
                    </select>
                }
                {
                    isMultiple && <Select
                        closeMenuOnSelect={false}
                        isMulti
                        value={answerSelectedList}
                        options={questionAnswers}
                        onChange={this.handleMultiSelection}
                        classNamePrefix="select"
                        isDisabled={this.props.disabled}
                    />
                }

            </div>
        );
    }
}

export default InstitutionViewer;
